import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CiHeart } from "react-icons/ci";
import { IconButton, Box, Modal, Rating } from "@mui/material";
import { Card } from "@material-tailwind/react";
import { IoEyeSharp } from "react-icons/io5";
import { openWhislist, } from "../../Redux/Action/action";
import { useDispatch, useSelector } from "react-redux";
import "../style/responsive.css";
import { IKImage } from "imagekitio-react";
import { IoClose } from "react-icons/io5";
import Eyes from "../ShopItems/Eyes";
import AOS from "aos";
import "aos/dist/aos.css";
import { FaHeart } from "react-icons/fa";
import { whislistDataAction } from "../../Redux/Action/whislistDataAction";

const AllProductData = (props) => {
    const {prdname,rating,prdimg,id}=props;

    const [openImgComp, setOpenImgComp] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);
    const [isLiked, setIsLiked] = useState(false);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const allWishListData = useSelector(state => state.whislistDataReducer.allWishList)

    useEffect(() => {
      setIsLiked(allWishListData.includes(id));
    }, [id, allWishListData])

    const handleOpenUserPage = (productId) => {
        const existingIds = JSON.parse(localStorage.getItem("productids")) || [];
        
        if(!existingIds.includes(productId)){
          existingIds.push(productId);
          localStorage.setItem("productids", JSON.stringify(existingIds));
          dispatch(whislistDataAction(existingIds))
        }
        dispatch(openWhislist(true));
    
      };

    const handleOpenImgComp = () => {
        setSelectedItem(id);
        setOpenImgComp(true);
    };

    const handleCloseImgComp = () => {
        setOpenImgComp(false);
    };

    const navigateShop = (e) => {
        if (id) {
            navigate(`/shop?id=${id}`);
        }
    };

    useEffect(() => {
        AOS.init({
            duration: 800,
            easing: "ease-in-out",
            once: true,
        });
    }, []);

    const handleLike = () => {
        setIsLiked(allWishListData);
        handleOpenUserPage(id);
      };

    return (
        <div>
            <Modal
                open={openImgComp}
                onClose={handleCloseImgComp}
                aria-labelledby="parent-modal-title"
                aria-describedby="parent-modal-description"
            >
                <Box className="eyes-box">
                    <div className="flex justify-end ">
                        <IconButton
                            onClick={handleCloseImgComp}
                            className="text-3xl  mt-5"
                            style={{ backgroundColor: "white" }}
                        >
                            <IoClose />
                        </IconButton>
                    </div>
                    <Eyes style={{ marginTop: "0 !important" }} itemId={selectedItem} />
                </Box>
            </Modal>


            <Card
                className=" flex justify-center mx-3"
                data-aos="fade-up"
                data-aos-anchor-placement="top-bottom"
                key={id}
            >
                <div
                    className="rounded  mt-2 p-0 "
                    style={{
                        maxWidth: "100%",
                        maxHeight: "100%",
                        height: "97%",
                        width: "100%",
                    }}
                >
                    <div className="relative ">
                        <div className="w-full">
                            {prdimg && typeof prdimg === "string" && (
                                <IKImage
                                    src={JSON.parse(prdimg)[0]?.url}
                                    style={{ width: "100%" ,height: "100%"}}
                                    className=" cursor-pointer h-full w-full"
                                    onClick={navigateShop}
                                />
                            )}

                            <p
                                onClick={navigateShop}
                                className="addToCartText absolute lg:left-full text-center w-full transform   transition-opacity duration-300 bg-black text-white px-4 py-2  cursor-pointer"
                            >
                                Read More
                            </p>
                            <IconButton
                                aria-label="delete"
                                className="IoEyeSharp"
                                onClick={handleOpenImgComp}
                            >
                                <IoEyeSharp style={{ fontSize: "20px" }} />
                            </IconButton>
                        </div>
                        <IconButton
                            aria-label="like"
                            className="heartIcons"
                            onClick={() => {
                                handleLike();
                            }}
                        >
                            {isLiked ? <FaHeart style={{ fontSize: "15px", color: "rgb(39 39 39)" }} /> : <CiHeart style={{ fontSize: "20px" }} />}
                        </IconButton>
                        <div className="m-2">
                            <div
                                className="text-xl text-font mt-3 overflow-hidden   "
                                style={{ color: " rgb(157 68 28 )" }}
                            >
                                <div className="normal-case">{prdname}</div>
                            </div>
                            <div className=" overflow-hidden">
                                <div className="text-xs">
                                    Price On Request
                                </div>
                            </div>
                            <span>
                                {rating ? (
                                    <span>

                                        <Rating
                                            name="read-only"
                                            value={rating}
                                            size='small'
                                        />

                                    </span>
                                ) : (
                                    <span></span>
                                )}
                            </span>
                        </div>
                    </div>
                </div>
            </Card>
        </div>
    )
}

export default AllProductData
